// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionReviews_section__q_e0n","heading":"SectionReviews_heading__cUeDx"};